module.exports = __webpack_public_path__ + "img/twitter.454a257f.svg";